import React from 'react';
import { Button, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import styles from './ThemeToggle.module.css';

const ThemeToggle = ({ size = 'default', type = 'text', className = '' }) => {
  const { theme, toggleTheme, isDark } = useTheme();
  const { t } = useTranslation();

  const tooltipTitle = isDark ? t('switchToLight') : t('switchToDark');
  const icon = isDark ? <SunOutlined /> : <MoonOutlined />;
  const ariaLabel = isDark ? t('switchToLight') : t('switchToDark');

  return (
    <Tooltip title={tooltipTitle} placement="bottom">
      <Button
        type={type}
        size={size}
        icon={icon}
        onClick={toggleTheme}
        className={`${styles.themeToggle} ${className}`}
        aria-label={ariaLabel}
        title={tooltipTitle}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
